import React, { Fragment } from "react";

const Body = ({ renderField, renderCheckbox, ...props }) => {
    const { name, planStayPeriod, isVisitOptional } = props;
    return (
        <Fragment>
            {renderField(name)}
            {renderField(planStayPeriod)}
            {renderCheckbox(isVisitOptional)}
        </Fragment>
    );
};

export default Body;
